import Vue from 'vue';
import App from './App.vue';
import router from '@/router/index';
import store from '@/store/index';
import FastClick from 'fastclick';
import 'lib-flexible'; // 淘宝适配方案
import '@admin/fe2app-sdk';
import {
  isLjds,
  isYdk,
  isTz,
  isWechat,
  getParams,
  isSandbox,
  isWxMiniprogram,
  isInApp,
  gotoMMCclient,
} from './common/utils/tools';
import { Spinner, InfiniteScroll } from 'mint-ui';
import wxShare from '@/common/utils/wxShare';
import { authPath, isOverseaPlatform, isZhCn, overPath } from '@/common/js/liveConfig';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import 'vant/lib/index.css';
import {
  Picker,
  Image as VanImage,
  Popup,
  Area,
  Tab,
  Tabs,
  Loading,
  Skeleton,
  PullRefresh,
  List,
  Circle,
  Sticky,
  Swipe,
  SwipeItem,
  Stepper,
  Toast,
  Dialog,
  NoticeBar,
  Icon,
  Button,
  Field,
  Checkbox
} from 'vant';
import VueLazyload from 'vue-lazyload';
import lottie from 'vue-lottie';
import '@/common/js/report';
import axios from 'axios';
import { Sense } from '@/common/js/senseSdk';
import request from '@/service/request';
Sense.init(
  {app_id: 'S49', // 业务线id
  product_id: '159714467600000010',
  app_version: 'H5-live',}
);

Vue.component('lottie', lottie);
Vue.use(Checkbox);
Vue.use(VanImage);
Vue.use(Picker);
Vue.use(Button);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Area);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Loading);
Vue.use(Skeleton);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Circle);
Vue.component(Spinner.name, Spinner);
Vue.use(InfiniteScroll);
Vue.use(Sticky);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Stepper);
Vue.use(NoticeBar);
Vue.use(Toast);
Vue.use(Dialog);

// 绑定fastclick
// (FastClick as any).attach(document.body);

Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://img-fe.tengzhihh.com/image/5d880975600c42-750x578.jpg',
  loading: 'https://img-fe.tengzhihh.com/image/0e708a4b125a61-750x578.jpg',
  attempt: 1,
});
if (isWxMiniprogram()) {
  const open_id = getParams('open_id') || '';
  localStorage.setItem('open_id', open_id);
}

if (isInApp()) {
  axios.defaults.headers['system'] = 'app_web';
  if (!isZhCn()) {
    axios.defaults.headers['Lang'] = 'zh-TW';
  }
}

setTimeout(() => {
  let mmc = (window as any).mmc;
  console.log('-----mmc-----');
  console.log(mmc, mmc.user.getInfo(), mmc.afterReady);
  console.log('-----mmc-----');
}, 2000);

router.beforeEach(async (to, from, next) => {
  // 判断页面活动是否结束
  if (overPath.includes(to.path)) {
    Toast('活动已结束');
    next();
  }
  let platform = getParams('platform') || '';
  if (platform) {
    localStorage.setItem('platform', platform);
    store.commit('login/UPDATE_PLATFORM', platform);
    axios.defaults.headers['platform'] = platform;
  }
  let verify = getParams('verify') || '';
  if (verify) {
    localStorage.setItem('verify', verify);
  }
  // 判断是否需要到授权页微信授权
  if (isWechat() && authPath.includes(to.path)) {
    let urlToken = getParams('token') || '';
    let localToken = localStorage.getItem('tToken') || '';
    if (urlToken) {
      localStorage.setItem('tToken', urlToken);
      store.commit('login/UPDATE_TOKEN', urlToken);
    } else if (!localToken) {
      let channel = getParams('channel') || '';
      let host = isSandbox() ? 'https://sandbox-m.yiqiwen.cn' : 'https://m.yiqiwen.cn';
      let redirect_url = encodeURIComponent(location.href);
      location.href = `${host}/dist/liveAuth.html?channel=${channel}&redirect_url=${redirect_url}`;
    }
  }

  // 判断是否在灵机大师APP内，是否需要登录
  if (
    (isLjds() && to.meta.needLoginLjds) ||
    (isYdk() && to.meta.needLoginYdk) ||
    (isTz() && to.meta.needLoginTz)
  ) {
    console.log(isYdk(), 'isYdk', '---需要登录---', (window as any).mmc.afterReady, 'afterReady');
    try {
      //出现过没token但是(window as any).mmc.afterReady为true的情况，所以从请求头拿token判断一下
      let requestHeaderToken =
        axios.defaults.headers['Authorization'] || axios.defaults.headers['YQW-Token'];
      if (!(window as any).mmc.afterReady || !requestHeaderToken) {
        (window as any).mmc.init();
        console.log(`window.mmc.init`, (window as any).mmc.init);
        let tryCount = 0;
        const fun = () => {
          tryCount++;
          let userInfo = (window as any).mmc.user.getInfo();
          if (!userInfo.token) {
            if (tryCount < 20) {
              return setTimeout(() => {
                return fun();
              }, 100);
            } else {
              (window as any)._MMCMainTryCount = 20;
              console.log(`_MMCMainTryCount`, 20);
              next();
              console.log('-userInfo', userInfo);
            }
            return;
          }
          let {
            token,
            platform,
            deviceid,
            channel,
            userid,
            avatar,
            nickname,
            version,
            datacenter_id = '',
            user_center_id = '',
            product_id = '',
            appid,
          } = userInfo;

          if (token && platform) {
            localStorage.setItem('platform', platform);
            axios.defaults.headers['Authorization'] = token;
            axios.defaults.headers['YQW-Token'] = token;
            axios.defaults.headers['platform'] = platform;
            axios.defaults.headers['platformid'] = platform;
            axios.defaults.headers['DeviceId'] = deviceid;
            axios.defaults.headers['Publisher-Id'] = 4;
            axios.defaults.headers['channel'] = channel;
            axios.defaults.headers['version'] = version;
            store.commit('login/UPDATE_TOKEN', token);
            store.commit('login/UPDATE_PLATFORM', platform);
            store.commit('login/UPDATE_DEVICEID', deviceid);
            store.commit('login/UPDATE_APPCHANNEL', channel);
            store.commit('login/UPDATE_USERID', userid);
            store.commit('login/UPDATE_VERSION', version);
            store.commit('login/UPDATE_AVATAR', avatar);
            store.commit('login/UPDATE_NICKNAME', nickname);
            localStorage.setItem('tToken', token);
            if (!isZhCn()) {
              axios.defaults.headers['Lang'] = 'zh-TW';
            }
          }
          next();
        };
        setTimeout(() => {
          fun();
        }, 100);
      } else {
        (window as any)._MMCafterReady = false;
        console.log(`afterReady`, false);
      }
    } catch (error) {
      console.log(error);
      Toast('获取用户信息失败');
    }
  }

  // H5环境接收链接带过来的token
  if (
    (!isLjds() && !isYdk() && !isTz() && !isWechat()) ||
    getParams('isGetToken') ||
    isWxMiniprogram()
  ) {
    let urlToken = getParams('token') || '';
    if (urlToken) {
      console.log(urlToken, 'urlToken链接带了token');
      localStorage.setItem('tToken', urlToken);
    }
    try {
      const ucToken = getParams('uc_token') || '';
      if (ucToken) {
        let channel = getParams('channel') || '';
        const data: any = {
          token: ucToken,
          platform: '16',
          channel,
        };
        if (getParams('schannel')) {
          data.schannel = getParams('schannel');
        }
        const res: any = await request('post', '/api/login/union', data);
        localStorage.setItem('tToken', res.token);
      }
    } catch (error) {
      console.error(error);
    }
  }

  next();
});

// axios.get('/v1/svip/info').then((res) => {
// 	store.commit("login/UPDATE_SVIPINFO", res);
// })

router.afterEach((to) => {
  console.log(location.origin + '/live' + to.fullPath);
  // 设置页面标题
  document.title = to.meta.title || '';
  if (!isZhCn() && to.fullPath.startsWith('/yunshi')) {
    document.title = '個人運勢';
  }
  // 微信分享前初始化 wxConfig
  wxShare.initConfig(location.origin + '/live' + to.fullPath);
});

function isShowVConsole() {
  let host = location.host;
  let search = location.search;
  return (
    /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(host) ||
    /localhost/i.test(host) ||
    /sandbox/i.test(host) ||
    /isShowVConsole=1/.test(search)
  );
}
// 初始化vConsole
const initVConsole = () => {
  return new Promise((resolve: any) => {
    if (!isShowVConsole()) {
      return resolve();
    }
    try {
      let a = document.createElement('script');
      a.src = '/static/vconsole@3.12.0.min.js';
      a.onload = () => {
        (window as any).vConsole = new (window as any).VConsole();
        resolve();
      };
      document.body.appendChild(a);
    } catch (err) {
      console.log(`err`, err);
      resolve();
    }
  });
};

if (isInApp()) {
  gotoMMCclient('web', 'set_normal_titlebar', {});
}

// 执行初始化函数
(async () => {
  await initVConsole();
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
})();
